// src/hooks/useWebsiteInfo.js
import React, { useMemo } from "react";
import { appName as configAppName } from "../config";
import { COMMON_WEB_PATH, DATA2_PATH } from "../constant";
import i18next from "i18next";

const useWebsiteInfo = () => {
  return useMemo(() => {
    const currentUrl = window.location.hostname;
    const basePath = `${COMMON_WEB_PATH}/FlyDragon/`;

    // 圖片檔名列表
    const commonImageNames = {
      hintBG: "hintBG.webp",
      hintTitleBG: `hintTitleBG.webp`,
      hintWORD: `hintWORD${
        i18next.language == "tw" ? "" : `_${i18next.language}`
      }.webp`,
      over18BTN: `over18BTN${
        i18next.language == "tw" ? "" : `_${i18next.language}`
      }.webp`,
      under18BTN: `under18BTN${
        i18next.language == "tw" ? "" : `_${i18next.language}`
      }.webp`,
      clickBoxBG: "clickBoxBG.webp",
      r18Logo: "R18_logo.webp",
      greenCheck: "greenCheck.svg",
      yesBTN: "yesBTN.webp",
      yesWORD: "yesWORD.webp",
      cancelBTN: "cancelBTN.webp",
      headerLeft: "headerLeft.webp",
      titleBG5: "titleBG5.webp",
      NunberBG: "NunberBG.webp",
      memberBTN: "memberBTN.webp",
      loginBTN: `loginBTN${
        i18next.language == "tw" ? "" : `_${i18next.language}`
      }.webp`,
      getREAL: `getREAL${
        i18next.language == "tw" ? "" : `_${i18next.language}`
      }.webp`,
      refresh: "refresh.webp",
      volumeBG: "volumeBG.webp",
      volumeTrackBG: "volumeTrackBG.webp",
      volumeTrackBG_mute: "volumeTrackBG_mute.webp",
      volumeThumbBG: "volumeThumbBG.webp",
      music: "music.webp",
      mute: "mute.webp",
      volumeICON: "volumeIcon.webp",
      muteICON: "muteIcon.webp",
      MENU_CONTAINER: "game-type-icon/MENU_CONTAINER.png",
      // Home.js的圖
      TOP_GAMES_BG: "TOP_GAMES_BG2x2.webp",
      TopGameTitleBG: "TopGameTitleBG.webp",
      topGameBG_mobile: "topGameBG_mobile2.webp",
      TWGameBG: `TWGameBG${
        i18next.language == "tw" ? "" : `_${i18next.language}`
      }.webp`,
      // CarouselV4 的圖
      animation_BG_frame: "animation_BG_frame2x.webp",
      // BalanceV4 的圖
      credit_border: "credit_border.png",
      credit_word: `credit_word.png`,
      // TaiwanMenu 的圖
      TWGameTitle_pc: `TWGameTitle_pc2${
        i18next.language == "tw" ? "" : `_${i18next.language}`
      }.webp`,
      dice_animation: "dice_animation.png",
      disc_animation: "disc_animation.png",
      fish_animation: "fish_animation.png",
      // 投注紀錄
      closeBetRecord: "closeBetRecord.webp",
      betRecordSelectBG: "betRecordSelectBG.webp",
      betRecordSelectArrow: "betRecordSelectArrow.webp",
      selectMenuBG: "selectMenuBG.webp",
      betRecordInnerBG: "betRecordInnerBG.webp",
      betRecordICONheader: `betRecordICONheader${
        i18next.language == "tw" ? "" : `_${i18next.language}`
      }.webp`,
      betTitle1: `betTitle1${
        i18next.language == "tw" ? "" : `_${i18next.language}`
      }.webp`,
      orderNumber: `orderNumber${
        i18next.language == "tw" ? "" : `_${i18next.language}`
      }.webp`,
      winLose: `winLose${
        i18next.language == "tw" ? "" : `_${i18next.language}`
      }.webp`,
      // GameSelector 的圖
      game_BG: "game_BG.webp",
      // MobileSearch 的圖
      searchBG: "searchBG.webp",
      // PlatformSelectorV4 的圖
      PlatformBG: "PlatformBG2.webp",
      ProviderNew: "ProviderNew.webp",
      ProviderNew_clicked: "ProviderNew_clicked.webp",
      // FooterV4 的圖
      WalletICON: "WalletICON.svg",
      PrizeICON: "PrizeICON.svg",
      ThumbUpICON: "ThumbUpICON.svg",
      SharreICON: "SharreICON.svg",
      // MarqueeListV4 的圖
      marqueeDarkBG: "marqueeDarkBG.webp",
      lngIcon: "lng_icon.png",
      //startGame
      startGame: `startGame${
        i18next.language == "tw" ? "" : `_${i18next.language}`
      }.webp`,
    };

    // 檢查網址是否包含 gd88 或 pc.gd88
    if (currentUrl.includes("gd88")) {
      // 預處理所有常用圖片路徑
      const processedImages = Object.fromEntries(
        Object.entries(commonImageNames).map(([key, name]) => [
          key,
          `${basePath}gd_${name}`,
        ])
      );

      return {
        websiteName: "金仁娛樂城",
        logoPath: `${process.env.REACT_APP_I18N_PATH}/logo/gd_logo_144.png?ddd`,
        isGD88: true,
        // 取得圖片路徑
        getImagePath: (path) => {
          if (path.includes("FlyDragon/")) {
            const basePath = path.substring(
              0,
              path.indexOf("FlyDragon/") + "FlyDragon/".length
            );
            const imageName = path.substring(
              path.indexOf("FlyDragon/") + "FlyDragon/".length
            );
            return `${basePath}gd_${imageName}`;
          }
          return path;
        },
        // 常用圖片路徑
        images: processedImages,
      };
    }

    // 預設網站配置
    const processedImages = Object.fromEntries(
      Object.entries(commonImageNames).map(([key, name]) => [
        key,
        `${basePath}${name}`,
      ])
    );

    return {
      websiteName: configAppName,
      logoPath: `${process.env.REACT_APP_I18N_PATH}/logo/logo_144.png?ddd`,
      isGD88: false,
      getImagePath: (path) => path,
      // 常用圖片路徑
      images: processedImages,
    };
  }, []);
};

export default useWebsiteInfo;
